var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('trend',{attrs:{"data":_vm.primeUserReportData,"gradient":['#007bff'],"stroke-width":1.5,"height":40,"width":200,"auto-draw":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }